import { render, staticRenderFns } from "./SelectorRole.vue?vue&type=template&id=382deddf&"
import script from "./SelectorRole.vue?vue&type=script&lang=js&"
export * from "./SelectorRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports